import { DatePipe } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorStateMatcher, MAT_DATE_FORMATS, MAT_NATIVE_DATE_FORMATS, NativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { BrowserModule, Meta } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LogoutConfimComponent } from 'src/app/logout-confim/logout-confim.component';
import { AccountLockedComponent } from './account-locked/account-locked.component';
import { AcknowledgementComponent } from './acknowledgement/acknowledgement.component';
import { BrAcknowledgementComponent } from './acknowledgement/br-acknowledgement/br-acknowledgement.component';
import { OusAcknowledgementComponent } from './acknowledgement/ous-acknowledgement/ous-acknowledgement.component';
import { ActionUiComponent } from './action-ui/action-ui.component';
import { AddressHistoryComponent } from './address-history/address-history.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent, CustomErrorStateMatcher } from './app.component';
import { AuthInterceptor } from './auth/auth-interceptor';
import { Authguard } from './auth/authguard';
import { AuthguardMain } from './auth/authguard.main';
import { AuthguardVendor } from './auth/authguard.vendor';
import { CertificationComponent } from './certification/certification.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { CpaComponent } from './cpa/cpa.component';
import { CreateProfileComponent } from './create-profile/create-profile.component';
import { CreateVendorProfileComponent } from './create-vendor-profile/create-vendor-profile.component';
import { CriminalHistoryOUSComponent } from './criminal-history/criminal-history-ous/criminal-history-ous.component';
import { CriminalHistoryComponent } from './criminal-history/criminal-history.component';
import { DirectorshipComponent } from './directorship/directorship.component';
import { DisputeAlreadySubmittedComponent } from './dispute-already-submitted/dispute-already-submitted.component';
import { DisputeFileDialogComponent } from './dispute-file-dialog/dispute-file-dialog.component';
import { DisputeQuestionnaireComponent } from './dispute-questionnaire/dispute-questionnaire.component';
import { EducationDialogComponent } from './education-history/education-dialog/education-dialog.component';
import { EducationHistoryComponent } from './education-history/education-history.component';
import { EmploymentHistoryDialogComponent } from './employment-history/employment-history-dialog/employment-history-dialog.component';
import { EmploymentHistoryComponent } from './employment-history/employment-history.component';
import { ErrorDialogComponent } from './error-dialog/error-dialog.component';
import { ErrorComponent } from './error/error.component';
import { FcraAuthorizationComponent } from './fcra-authorization/fcra-authorization.component';
import { FileDialogComponent } from './file-dialog/file-dialog.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { FooterComponent } from './footer/footer.component';
import { ForgotPasswordOTPComponent } from './forgot-password-otp/forgot-password-otp.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { HeaderComponent } from './header/header.component';
import { I9Component } from './i9/i9.component';
import { InlineStylesCSPModule } from './inline-styles-csp/inline-styles-csp.module';
import { IntroductionComponent } from './introduction/introduction.component';
import { LatestAALetterComponent } from './latest-aaletter/latest-aaletter.component';
import { LoadingComponent } from './loading/loading.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { MaterialModule } from './material.module';
import { NavigationComponent } from './navigation/navigation.component';
import { OtherBackgroundCheckComponent } from './other-background-check/other-background-check.component';
import { SummaryOfRightsComponent } from './other-background-check/summary-of-rights/summary-of-rights.component';
import { PCGBAMComponent } from './pc-gbam/pc-gbam.component';
import { PcMbamComponent } from './pc-mbam/pc-mbam.component';
import { PcSurveyComponent } from './pc-survey/pc-survey.component';
import { NationalDialogComponent } from './personal-information/national-dialog/national-dialog.component';
import { OtherNameComponent } from './personal-information/other-name/other-name.component';
import { PersonalDialogComponent } from './personal-information/personal-dialog/personal-dialog.component';
import { PersonalInformationComponent } from './personal-information/personal-information.component';
import { ProfessionalCertificationDialogComponent } from './professional-certification/professional-certification-dialog/professional-certification-dialog.component';
import { ProfessionalCertificationComponent } from './professional-certification/professional-certification.component';
import { ProgressbarComponent } from './progressbar/progressbar.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SafeHtmlPipe } from './safe-html.pipe';
import { SecurityQuestionsComponent } from './security-questions/security-questions.component';
import { ApiService } from './service/api.service';
import { CustomValidatorsService } from './service/custom-validators.service';
import { DateFormatPipe } from './service/dateFormatPipe';
import { EventService } from './service/event.service';
import { IntervalSessionService } from './service/interval-session.service';
import { SessionExpireComponent } from './session-expire/session-expire.component';
import { SessionTimedOutComponent } from './session-timed-out/session-timed-out.component';
import { SubmitCompleteComponent } from './submit-complete/submit-complete.component';
import { SubmitDialogComponent } from './submit-dialog/submit-dialog.component';
import { SuccessDialogComponent } from './success-dialog/success-dialog.component';
import { SuccessPasswordComponent } from './success-password/success-password.component';
import { SuccessProfileComponent } from './success-profile/success-profile.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { VendorBatchRequestComponent } from './vendor-batch-request/vendor-batch-request.component';
import { VendorDashboardComponent } from './vendor-dashboard/vendor-dashboard.component';
import { VendorRequestFormComponent } from './vendor-request-form/vendor-request-form.component';
import { VendorSearchResultsTakeActionComponent } from './vendor-search-results-take-action/vendor-search-results-take-action.component';
import { VendorSearchResultsComponent } from './vendor-search-results/vendor-search-results.component';
import { VersionComponent } from './version/version.component';
import { WetSignatureComponent } from './wet-signature/wet-signature.component';
import { CriminalRecordCertificateComponent } from './criminal-history/criminal-record-certificate/criminal-record-certificate.component';
import { InputsModule } from "@progress/kendo-angular-inputs";
import { ValidHelpLinkDialogComponent } from './certification/valid-help-link-dialog/valid-help-link-dialog.component';
import { AuthguardNHP } from './auth/authguard.nhp';
import { NonceService } from './inline-styles-csp/nonce.service';
import { AuthTitle } from './auth/auth-title';

export function initializeNonce(nonceService: NonceService) {
    return () => nonceService.fetchNonce();
}

@NgModule({
    declarations: [
        AppComponent,
        FooterComponent,
        HeaderComponent,
        ProgressbarComponent,
        LoginComponent,
        IntroductionComponent,
        NavigationComponent,
        CreateProfileComponent,
        OtherBackgroundCheckComponent,
        AcknowledgementComponent,
        PersonalInformationComponent,
        AddressHistoryComponent,
        EmploymentHistoryComponent,
        EducationHistoryComponent,
        ProfessionalCertificationComponent,
        CertificationComponent,
        FcraAuthorizationComponent,
        CriminalHistoryComponent,
        UnauthorizedComponent,
        ActionUiComponent,
        ForgotPasswordComponent,
        ChangePasswordComponent,
        SuccessProfileComponent,
        OtherNameComponent,
        DateFormatPipe,
        ForgotPasswordOTPComponent,
        SecurityQuestionsComponent,
        ResetPasswordComponent,
        SuccessPasswordComponent,
        WetSignatureComponent,
        LoadingComponent,
        ErrorComponent,
        FileUploadComponent,
        VersionComponent,
        SummaryOfRightsComponent,
        FileDialogComponent,
        DisputeFileDialogComponent,
        SuccessDialogComponent,
        SessionExpireComponent,
        SessionTimedOutComponent,
        SubmitDialogComponent,
        CpaComponent,
        SubmitCompleteComponent,
        LatestAALetterComponent,
        DisputeQuestionnaireComponent,
        DisputeAlreadySubmittedComponent,
        I9Component,
        PCGBAMComponent,
        PcMbamComponent,
        PcSurveyComponent,
        LogoutConfimComponent,
        CreateVendorProfileComponent,
        VendorDashboardComponent,
        VendorRequestFormComponent,
        VendorBatchRequestComponent,
        VendorSearchResultsComponent,
        VendorSearchResultsTakeActionComponent,
        ErrorDialogComponent,
        LogoutComponent,
        AccountLockedComponent,
        PersonalDialogComponent,
        SafeHtmlPipe,
        BrAcknowledgementComponent,
        OusAcknowledgementComponent,
        CriminalHistoryOUSComponent,
        DirectorshipComponent,
        EmploymentHistoryDialogComponent,
        EducationDialogComponent,
        ProfessionalCertificationDialogComponent,
        NationalDialogComponent,
        CriminalRecordCertificateComponent,
        ValidHelpLinkDialogComponent
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        FormsModule,
        MaterialModule,
        MatDatepickerModule,
        MatTableModule,
        NativeDateModule,
        AppRoutingModule,
        InlineStylesCSPModule,
        MatDialogModule,
        MatTabsModule,
        MatDividerModule,
        InputsModule
    ],
    exports: [ProgressbarComponent, NavigationComponent],
    providers: [ApiService, Authguard, AuthguardMain, AuthguardVendor, AuthguardNHP, EventService, DatePipe, SafeHtmlPipe, DateFormatPipe, CustomValidatorsService, Meta, ValidHelpLinkDialogComponent, AuthTitle,
        {
            provide: APP_INITIALIZER,
            useFactory: initializeNonce,
            deps: [NonceService],
            multi: true
        }, {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        { provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS },
        { provide: ErrorStateMatcher, useClass: CustomErrorStateMatcher },
        IntervalSessionService, { provide: MatDialogRef, useValue: {} }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(private sessionExpireService: IntervalSessionService) {

    }
}
